<template>
  <div class="animated fadeIn">
    <b-row class="justify-content-center" v-if="showList">
      <b-col md="7" lg="6">
        <b-card >
          <div slot="header">
            Master Sales Group
            <div class="card-header-actions">
              <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
              <button class="btn btn-danger mr-1" @click="close()">
                <i class="fa fa-close"></i> Close
              </button>
            </div>
          </div>
      <b-row>
        <b-col lg="5">
          <b-input-group>
              <b-input-group-prepend><span class="pt-2 pr-1">Filter</span></b-input-group-prepend>
              <b-form-input v-model="filter.area_name" @keyup.13.native="refresh()" placeholder="Name"></b-form-input>          
          </b-input-group>          
        </b-col>
        <b-col lg="3" v-if="(user.iklan==1)">
              <b-input-group >
                <b-input-group-prepend><span class="pt-2 pr-1">Iklan</span></b-input-group-prepend>
                  <b-form-select v-model="filter.iklan" :plain="true" :options="YesNoAll"></b-form-select>
              </b-input-group>
        </b-col>
        <b-col lg="4">
                <b-button variant="success" size="sm" @click="refresh()"><i class="fa fa-refresh"></i> Apply Filter</b-button>
                <b-button variant="secondary" size="sm" class="ml-2" @click="clearFilter()">Clear Filter</b-button>
        </b-col>
      </b-row>

          <b-table
            class="mb-0"
            ref="table"
            outlined
            responsive
            hover
            small
            style="font-size:smaller;"
            :items="data"
            :fields="tblFields"
            :current-page="tblData.page"
            :per-page="tblData.limit"
            :sort-by.sync="tblData.sortBy"
            :sort-desc.sync="tblData.sortDesc"
            @row-clicked="rowClicked"
          >
        <template v-slot:cell(index)="data">
          {{ (tblData.page - 1) * tblData.limit + (data.index + 1)}}
        </template>

        <template v-slot:cell(jmlae)="data">
                <span v-if="(data.item.jmlae)"><b-link @click.stop="showAreaMember(data.item)">{{data.item.jmlae}} Member</b-link></span>
                <span v-else ><b-link @click.stop="showAreaMember(data.item)">0 Member</b-link></span>
        </template>
        <template v-slot:cell(iklan)="data">
          <span v-if="data.item.iklan==1"><i class="fa fa-check "></i></span>
        </template>
        <template v-slot:cell(koran)="data">
          <span v-if="data.item.koran==1"><i class="fa fa-check "></i></span>
        </template>

            <template v-slot:cell(action)="data">
              <div class="text-center">
                <a href="javascript:void(0)" @click.stop="edit(data.item)">
                  <i class="fa fa-pencil"></i>
                </a>
                |
                <a
                  href="javascript:void(0)"
                  class="text-danger"
                  @click.stop="deleteConfirm(data.item)"
                >
                  <i class="fa fa-trash"></i>
                </a>
              </div>
            </template>
          </b-table>
          <b-row class="mt-2">
            <b-col cols="6">
              <div>
                Showing {{(tblData.page - 1) * tblData.limit + 1}}
                to
                <span
                  v-if="((tblData.page * tblData.limit)>tblData.total)"
                >{{tblData.total}}</span>
                <span v-else>{{tblData.page * tblData.limit}}</span>
                of {{tblData.total}} entries
              </div>
            </b-col>
            <b-col cols="6">
              <b-pagination
                align="right"
                :total-rows="tblData.total"
                :per-page="tblData.limit"
                v-model="tblData.page"
              ></b-pagination>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="7" lg="6">
        <b-card>
          <div slot="header">Group Sales - Add/Edit Form</div>
          <b-input-group >
            <b-input-group-prepend class="mr-4">
              <label>Group Sales</label>
            </b-input-group-prepend>
            <b-form-input v-model="frmdata.area_name" :state="!$v.frmdata.area_name.$error"></b-form-input>
          </b-input-group>
            <b-input-group >
                <b-input-group-prepend><label>&nbsp;</label></b-input-group-prepend>
              <b-form-checkbox v-if="user.iklan==1" class="ml-3 mt-2 mr-2" v-model="frmdata.iklan" value="1" unchecked-value="0"><b>Sales Iklan</b></b-form-checkbox>
              <b-form-checkbox v-if="user.koran==1" class="ml-3 mt-2 mr-2" v-model="frmdata.koran" value="1" unchecked-value="0"><b>Sales Koran</b></b-form-checkbox>
            </b-input-group>

          <div slot="footer" style="text-align:center;">
            <button class="btn btn-primary mr-1" @click="save()">
              <i class="fa fa-save"></i> Save
            </button>
            <b-button variant="secondary" class="mr-1" @click="closeFrm()">
              <i class="fa fa-close"></i> Close Form
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

      <b-modal v-model="areaMemberShow" header-bg-variant="primary"  title="Group Sales Member" size="md" :centered="true" :hide-footer="true">
            <b-input-group>
                <b-input-group-prepend><span class="p-2">Group Sales</span></b-input-group-prepend>
                <b-form-input v-model="model.area_name" readonly></b-form-input>
                <b-input-group-append>
                    <b-btn text="Button"  @click="lkuKoranSalesShow=true" class="ml-2">
                      <i class="fa fa-plus"></i> sales sbg member
                    </b-btn>
                </b-input-group-append>
              </b-input-group>

            <b-table
              class="mb-1"
              ref="tblMember"
            small
            style="font-size:smaller;"
              responsive
              striped 
              hover
              :items="areaMember.list"
              :fields="fields"
              :current-page="areaMember.page"
              :per-page="areaMember.limit"
              :sort-by.sync="areaMember.sortBy"
              :sort-desc.sync="areaMember.sortDesc" 
              :key="areaMember.page"
            >
            <template v-slot:cell(index)="data">
              {{ (areaMember.page - 1) * areaMember.limit + (data.index + 1)}}
            </template>

            <template v-slot:cell(action)="data">
              <div class="text-center">
                <a
                  href="javascript:void(0)"
                  class="text-danger"
                  @click.stop="delMember(data.item)"
                >
                  <i class="fa fa-trash"></i> Del
                </a>
              </div>
            </template>
            </b-table>
            <b-row class="mb-0">
                <b-col cols="7">
                  <b-row>
                      <span class="ml-3 pt-1 pr-1">Per page</span>
                      <b-form-select :options="[10, 20, 30, 50, 70, 90]" :plain="true" v-model="areaMember.limit"  size="sm" style="width:60px !important;"/>
                      <!-- <div class="pl-1 pt-1">
                        showing {{(areaMember.page - 1) * areaMember.limit + 1}}
                        to <span v-if="((areaMember.page * areaMember.limit)>areaMember.total)">{{areaMember.total}}</span> <span v-else>{{areaMember.page * areaMember.limit}}</span>
                        of {{areaMember.total}} 
                      </div>         -->
                  </b-row>
                </b-col>
                <b-col cols="5">            
                  <b-pagination
                    align="right"
                    :total-rows="areaMember.total"
                    :per-page="areaMember.limit"
                    v-model="areaMember.page"
                  ></b-pagination>
                </b-col>
              </b-row>        
      </b-modal>
      <b-modal v-model="lkuKoranSalesShow" size="lg" :hide-footer="true" title="List of Sales" :centered="true">
        <lku-salesae @click="onSelectSalese" :crudfilter="koraniklan"></lku-salesae>
      </b-modal>

      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>

  </div>
</template>


<script>
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import lkuSalesae from "../lookup/lkuSalesae";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  components: {lkuSalesae},
  mixins: [validationMixin],
  validations: {
    frmdata: {
      area_name: { required },
    }
  },
  data() {
    return {
      lkuKoranSalesShow: false,
      showDelConfirm: false,
      areaMemberShow: false,
      user : this.$store.state.user,
      areaMember:{
        list:[],
        page:1,
        total:0,
        limit: 10,
        sortBy: null,
        sortDesc: false
      },
      showList: true,
      showForm: false,
      frmdata: { area_name: "" },
      model: { area_name: "" },
      tblData: {
        tablename: "korangrouparea",
        page: 1,
        limit: 10,
        total: 0,
        sortBy: 'jmlae',
        sortDesc: true
      },
      tblFields: [
        {key: 'index', label: 'No.' ,thStyle: "width:40px"},                    
        {
          key: "area_name",
          label: "Nama Group Sales",
          sortable: true
        },
        {
          key: "jmlae",
          label: "Sales Member",
          sortable: true
        },
      ],
      fields: [
        {key: 'index', label: 'No.' ,thStyle: "width:40px"},                    
        {
          key: "salesae_name",
          label: "Nama Sales/AE",
          sortable: true
        },
        {
          key: "createby",
          label: "diinput oleh",
          sortable: true
        },
        {
          key: "action",
          label: "Action",
          thStyle: "width:60px",
          thClass: "text-center"
        }
      ],
      filter:{},
      YesNoAll:[
          {value:'1', text: 'YES'},
            {value:'0', text: 'NO'},
            {value:'', text: 'ALL'}],

    };
  },
  computed: {
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
    koraniklan() {
      if (this.frmdata.iklan==1) {
        return "iklan=1";
      } else if (this.frmdata.koran==1){
        return "koran=1";
      } else {
        return "";
      }
    }
  },
  created: async function() {
    // this.tblData.customQuery = this.crudfilter;    
    if (this.user.koran==1){
        this.tblFields.push({
            key: "koran",
            label: "Koran",
            thStyle: "width:80px",
            sortable: true
          });
    }
    if (this.user.iklan==1){
      this.tblFields.push( 
          {
            key: "iklan",
            label: "Iklan",
            thStyle: "width:80px",
            sortable: true
          },
      );      
    }
      this.tblFields.push( 
          {
            key: "action",
            label: "Action",
            thStyle: "width:60px",
            thClass: "text-center",
          },
      );      
  },  

  methods: {
    onSelectSalese: async function(_sales) {
      this.model.salesae_id = _sales.salesae_id;
      this.model.area_name = `${_sales.crewname || _sales.area_name}`;
      this.lkuKoranSalesShow = false;
        try {
            await crud.insert({
              tablename: "koranareasub",
              data: {
                area_id: this.model.area_id,
                salesae_id: this.model.salesae_id,
                createby: this.user.username,
              }
            });
            const par = {
              tablename: "koranareasub",page:1,limit: 1000,
              sortBy: this.areaMember.sortBy,
              sortDesc: this.areaMember.sortDesc,
              customQuery: `area_id=${encodeURIComponent(this.model.area_id)}`
            }
            const list = await crud.list(par);
            this.areaMember.total=list.total;
            this.areaMember.list=list;    

        } catch (error) {
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
        }

    },
    delMember: async function(item) {
          let jawaban = false;
          jawaban = await this.$bvModal.msgBoxConfirm(` ${item.area_name} sbg member Group akan dihapus, lanjutkan?`, {
                    title: 'Please Confirm',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'Iya',
                    cancelTitle: 'Tidak',
                    cancelVariant: 'danger',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                  });
          if (jawaban == true) {        
            try {
                await crud.remove({ tablename: "koranareasub", key: this.model.areasubKey });
                const par = {
                  tablename: "koranareasub",page:1,limit: 1000,
                  sortBy: this.areaMember.sortBy,
                  sortDesc: this.areaMember.sortDesc,
                  customQuery: `area_id=${encodeURIComponent(this.model.area_id)}`
                }
                const list = await crud.list(par);
                this.areaMember.total=list.total;
                this.areaMember.list=list;    
            } catch (error) {
                    console.log('error : ', error);
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }   
            }
          }   
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      let str='';
      if (this.filter.area_name){
        str += str ? '&' : '';
        str = str + 'area_name=' + encodeURIComponent(this.filter.area_name)+'%';
      }
      if (this.filter.iklan){
        str += str ? '&' : '';
        str = str + 'iklan=' + encodeURIComponent(this.filter.iklan)+'%';
      }

      const list = await crud.list(this.tblData);
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    add: function(data) {
      for (var key in this.frmdata) {
        this.frmdata[key] = "";
      }
      this.showForm = true;
      this.showList = false;
    },
    edit: async function(data) {
      this.model = data;
      for (var key in this.frmdata) {
        this.frmdata[key] = "";
      }
      for (var key in this.model) {
        this.frmdata[key] = this.model[key];
      }
      this.frmdata.idlama = data.area_id;
      this.showForm = true;
      this.showList = false;
    },
    save: async function(callback) {
      if (this.invalidFormdata) {
        console.log("validation : ", this.$v.frmdata);
        console.log("frmdata : ", this.frmdata);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        try {
          this.frmdata.iklan=this.frmdata.iklan || '0';                   
          this.frmdata.koran= this.frmdata.koran || '0';              
          if (this.frmdata.idlama) {
            await crud.update({
              tablename: "korangrouparea",
              key: this.frmdata.idlama,
              data: {
                area_name: this.frmdata.area_name,
                koran:this.frmdata.koran,                   
                iklan:this.frmdata.iklan,                   
              }
            });
          } else {
            await crud.insert({
              tablename: "korangrouparea",
              data: {
                area_name: this.frmdata.area_name,
                koran:this.frmdata.koran,                   
                iklan:this.frmdata.iklan,                   
              }
            });
          }
          this.closeFrm();
          setTimeout(() => {
            this.refresh();
          }, 500);
        } catch (error) {
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
        }
      }
    },
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await crud.remove({ tablename: "korangrouparea", key: this.model.area_id });
      this.refresh();
    },
    rowClicked(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    closeFrm() {
      this.showForm = false;
      this.showList = true;
    },

    showAreaMember: async function(record) {
      try {
        this.model = record;
        this.isLoading=true;
        const par = {
          tablename: "koranareasub",page:1,limit: 1000,
          sortBy: this.areaMember.sortBy,
          sortDesc: this.areaMember.sortDesc,
          customQuery: `area_id=${encodeURIComponent(this.model.area_id)}`
        }
        const list = await crud.list(par);
        console.log('member list: ',list);
        this.areaMember.page=1;
        this.areaMember.total=list.total;
        this.areaMember.list=list;    

        this.areaMemberShow=true;            
        this.isLoading=false;
      } catch (error) {
        this.isLoading=false;
        if (error.message) {
            toastr.error(error.message,'ERROR MESSAGE',10000);
        } else {
            toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
        }                
      }

    },
    clearFilter(ctx) {
      this.tblData.area_name = "";
      this.tblData.iklan = "";
      // this.refresh();
    },    

    close() {
      router.push({path: "home"});
    }
  }
};
</script>
